const V = {
  name: "CarTopView",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 10H3V8H5V3C5 1.34315 6.34315 0 8 0H16C17.6569 0 19 1.34315 19 3V8H21V10H19V21C19 22.6569 17.6569 24 16 24H8C6.34315 24 5 22.6569 5 21V10ZM16 22C16.5523 22 17 21.5523 17 21V19H7V21C7 21.5523 7.44771 22 8 22H16ZM17 17V10H7V17H17ZM7 3V8H17V3C17 2.44772 16.5523 2 16 2H8C7.44771 2 7 2.44772 7 3Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as CarTopView
};
